export const SURVEY_SECTION_END = 'end';
export const SURVEY_SECTION_LANDING = 'landing';
export const SURVEY_SECTION_PREVIEW = 'preview';
export const SURVEY_SECTION_QUESTIONS = 'questions';
export const SURVEY_SECTION_SETTINGS = 'settings';
export const SURVEY_SECTION_STYLING = 'globalStyling';
